const innerHero = document.querySelector('#js-innerHero-swiper')

if(innerHero) {
  const innerHeroSwiper = new Swiper('#js-innerHero-swiper', {
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 4000,
    },
    pagination: {
      el: '.l-innerHero__pager',
      type: "fraction",
    },
    navigation: {
      nextEl: '.l-innerHero__button-next',
      prevEl: '.l-innerHero__button-prev',
    },
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      767: {
        navigation: {
          nextEl: '.l-innerHero__button-next-pc',
          prevEl: '.l-innerHero__button-prev-pc',
        }
      }
    }
  });
}